import Vue from "vue";
import Vuex from "vuex";
import VuexPersistance from "vuex-persist";
import axios from "../config";

Vue.use(Vuex);
const vuexLocal = new VuexPersistance({
  storage: window.localStorage
});
export default new Vuex.Store({
  state: {
    userAccount: {
      userName: "",
      password: "",
      role: "",
      profileName:"",
      domain:""
    },
    print:false,
    uiAccept:{},
    searchPurchase:"",
    searchType:"",
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    updateUserAccount: function(state, value) {
      state.userAccount = value;
      if (value.password != undefined) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `gps${value.password}`;
      } else {
        axios.defaults.headers.common["Authorization"] = `gps`;
      }
    },
    removeUserAccount: function(state) {
      state.userAccount = {};
    },
    updatePrint: function(state,value) {
      state.print = value;
    },
    updateUiAccept: function(state,value) {
      state.uiAccept = value;
    },
    updateSearchPurchase: function(state,value) {
      state.searchPurchase = value;
    },
    updateSearchType: function(state,value) {
      state.searchType = value;
    },
  },
  actions: {}
});
